// src/lib/blog/config/tags.ts

/**
 * Blog tags configuration
 * This is the single source of truth for all blog tags
 */
export const TAGS = [
  // Analytics & Performance
  'creative-intelligence',
  'performance-analytics',
  'ai-insights',
  'media-strategy',
  'industry-solutions',
  'platform-expertise',
  'thumbstop-rate',
  'paid-media',
  
  // Creative Development
  'creative',
  'design',
  'creative-testing',
  'creative-strategy',
  'creative-optimization',
  'ad-creative-scoring',
  'ad-fatigue-detection',
  'creative-benchmarking',
  'creative-testing-framework',
  'visual-element-analysis',
  'messaging-effectiveness',
  'creative-optimization-insights',
  'ugc-performance-analysis',
  'user-generated-content-ugc',
  
  // Performance Metrics
  'ad-performance-analytics',
  'conversion-rate-optimization',
  'engagement-metrics',
  'creative-roi-tracking',
  'performance-benchmarks',
  'competitive-analysis',
  'performance-creative',
  'data-analytics',
  'data-science',
  
  // Platform Specific
  'meta-ads-analysis',
  'meta-ad-creative',
  'tiktok-creative-intelligence',
  'tiktok-ad-creative',
  'youtube-ad-optimization',
  'youtube-ad-creative',
  'google-ads-creative-insights',
  'google-ad-creative',
  'cross-platform-analysis',
  'linkedin-ad-creative',
  
  // Business Categories
  'ecommerce-advertising',
  'b2b-marketing-analytics',
  'dtc-brand-optimization',
  'enterprise-solutions',
  'agency-tools',
  'business-to-business-b2b',
  'business-to-consumer-b2c',
  'direct-to-consumer-dtc',
  'ecommerce',
  
  // Strategy & Innovation
  'digital-marketing-strategy',
  'social-media-advertising',
  'ad-tech-innovations',
  'media-buying-planning',
  'industry-trends',
  'marketing-automation',
  'programmatic-advertising',
  'emerging-platforms',
  
  // Specialized Topics
  'audience-targeting',
  'customer-journey-optimization',
  'marketing-attribution',
  'cross-channel-marketing'
] as const
